import { Platform } from 'react-native';
import Expo from 'expo';

export const isWeb = Platform.OS === 'web';
export const isNative = !isWeb;
export const isAndroid = Platform.OS === 'android';
export const isIOS = Platform.OS === 'ios';
export const isIphoneX = isIOS && Expo.Constants.platform.ios.model.toLowerCase().includes('iphone x');
// Firefox 1.0+
export const isFirefox = isWeb && typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
// prettier-ignore
export const isSafari = isWeb && (/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))); // eslint-disable-line

// Internet Explorer 6-11
// prettier-ignore
export const isIE = isWeb && ( /*@cc_on!@*/false || !!document.documentMode);

// Edge 20+
export const isEdge = isWeb && !isIE && !!window.StyleMedia;

// Chrome 1 - 71
export const isChrome = isWeb && !!window.chrome && !isEdge;

export { Platform };



// WEBPACK FOOTER //
// ./src/components/core/platform.js